import { useEffect, useState } from "react";

// The Popover continues to render Popover.Content for X milliseconds after the popover is closed.
// To prevent the popover content from appearing empty, we need to continue to show it inside Popover.Content for X milliseconds.
// This is just a hack until we have a `onCloseAnimationEnd` prop on Popover.
export const usePopoverCloseDelayWorkaround = (
  popoverOpen: boolean,
  delay: number = 300,
) => {
  const [shouldShowContent, setShouldShowContent] = useState(popoverOpen);

  useEffect(() => {
    if (!popoverOpen) {
      const timeout = setTimeout(() => {
        setShouldShowContent(false);
      }, delay);
      return () => clearTimeout(timeout);
    }
    setShouldShowContent(true);
  }, [popoverOpen, delay]);

  return shouldShowContent;
};
